import { useState, type CSSProperties } from 'react';
import { INTEGRATIONS_SECTION } from '../../../data/site';

export function IntegrationsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeTab = INTEGRATIONS_SECTION.tabs[activeIndex];

  return (
    <section
      className="integrations integrations-pro"
      style={
        {
          '--integrations-accent': activeTab.accent,
        } as CSSProperties
      }
    >
      <div className="container">
        <div className="integrations-pro__layout">
          <div className="integrations-pro__content">
            <div className="integrations-pro__eyebrow">{INTEGRATIONS_SECTION.eyebrow}</div>
            <h3 className="integrations-pro__heading">
              {INTEGRATIONS_SECTION.title}
              <span className="integrations-pro__heading-accent">{INTEGRATIONS_SECTION.titleAccent}</span>
            </h3>
            <p className="integrations-pro__subtitle">{INTEGRATIONS_SECTION.subtitle}</p>

            <div className="integrations-pro__tabs" role="tablist" aria-label="Platform layers">
              {INTEGRATIONS_SECTION.tabs.map((tab, index) => {
                const isActive = index === activeIndex;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    className={`integrations-pro__tab${isActive ? ' is-active' : ''}`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <span className="integrations-pro__tab-index">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="integrations-pro__tab-body">
                      <span className="integrations-pro__tab-title">{tab.title}</span>
                      <span
                        className="integrations-pro__tab-details"
                        aria-hidden={!isActive}
                      >
                        {tab.description}
                      </span>
                    </span>
                    <span className="integrations-pro__tab-arrow" aria-hidden="true">
                      →
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="integrations-pro__visual">
            <div className="integrations-pro__orbit" aria-hidden="true">
              <div className="integrations-pro__ring" />
              <div className="integrations-pro__ring integrations-pro__ring--inner" />
              <div className="integrations-pro__ring integrations-pro__ring--glow" />
            </div>

            <div className="integrations-pro__image-wrap">
              <img
                src={INTEGRATIONS_SECTION.image}
                loading="lazy"
                alt={INTEGRATIONS_SECTION.imageAlt}
                className="integrations-pro__image"
              />
            </div>

            <div className="integrations-pro__stat">
              <span className="integrations-pro__stat-value">4</span>
              <span className="integrations-pro__stat-label">Layers, one platform.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
